export * from './Spinner';
import Spinner from './Spinner';
export default Spinner;
